/*@ngInject*/
const SubmitModificationsRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.submitModifications = function (submissionId) {
        var url = '/rest/Submission/' + submissionId + '/submitModifications';

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('submitModificationsRepository', SubmitModificationsRepository);
